import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../../providers/AuthContext";
function Header() {
  let { user } = useAuth();
  // console.log(state);
  let navigate = useNavigate();
  const handleLogout = async () => {
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}logout`, {
        method: "POST",
        credentials: "include"
      });
      if(res.ok){
        if (!res.ok) throw new Error("Logout Failed");
        navigate(0); //Refresh page       
      }
    } catch (error) {
      console.error("Logout Failed", error);
    }    
  };
  return (
    <>
   
      <header className="site-header">
  <div className="container">
    <div className="logo-wrap d-flex">
      <img
          src={process.env.PUBLIC_URL + "/favicon.png"}
          alt="banner"
          className="logo img-fluid"
        />
      <div className="logo-text">
        <h1>Velama<br />Pelli Pandiri</h1>
        <p>Trusted Matrimonial Service</p>
      </div>
    </div>
  </div>
</header>

      {user && (
        <><nav className="main-nav navbar navbar-expand-lg">
          <div className="container">
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
               data-bs-target="#mainNav"
            >
              <span className="navbar-toggler-icon"></span>
            </button>
            <div className="collapse navbar-collapse" id="mainNav">
              <ul className="navbar-nav me-auto">
                <li className="nav-item">
                  <NavLink
                    className="nav-link"
                    to={process.env.PUBLIC_URL + "/"}
                  >
                    Profiles
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink
                    className="nav-link"
                    to={process.env.PUBLIC_URL + "/matrimony"}
                  >
                    Add Profile
                  </NavLink>
                </li>
                {user.role === "admin" && (
                  <>
                    <li className="nav-item">
                      <NavLink
                        className="nav-link"
                        to={process.env.PUBLIC_URL + "/pendingProfiles"}
                      >
                        Pending Profiles
                      </NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink
                        className="nav-link"
                        to={process.env.PUBLIC_URL + "/inactiveProfiles"}
                      >
                        Inactive Profiles
                      </NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink
                        className="nav-link"
                        to={process.env.PUBLIC_URL + "/viewManagers"}
                      >
                        Managers
                      </NavLink>
                    </li>
                  </>
                )}
                {/* <li className="nav-item">
  <a className="nav-link" href="#">Link</a>
</li> */}
              </ul>
            </div>
            {/* <ul className="navbar-nav d-flex ">
    
    <li className="nav-item pull-right">
      <a className="nav-link" href="#"><i className="fa fa-sign-out" aria-hidden="true"></i> Log Out</a>
    </li>
  </ul> */}
            <div className="d-flex align-content-center gap-3">
              <span class="welcome-badge"><i class="fas fa-user-shield me-1"></i>Welcome {user.name}</span>
              <button
                className="btn-logout"
                onClick={handleLogout}
              >
                <i className="fas fa-sign-out-alt" aria-hidden="true"></i> Log Out
              </button>
            </div>
          </div>
        </nav></>
      )}
    </>
  );
}
export default Header;
